module.exports = "<app-navbar></app-navbar>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main